module.exports = __webpack_public_path__ + "img/ep-baleine.fd2749c8.jpg";